import logo from './logo.svg';
import './App.css';
import { useNavigate, useRoutes } from 'react-router-dom';
import RootStoreContext from '@context/RootStoreContext';
import RootStore from '@stores/RootStore';
import { ThemeProvider } from '@mui/material';
import DefaultTheme from '@themes/DefaultTheme';
import RouterStore from '@stores/RouterStore';
import Routes from './shared/Routes';
import ValidatorService from '@services/ValidatorService';
import Validator from 'validatorjs';
import { useEffect } from 'react';
import Toast from '@components/common/toast/components/Toast';

var validatorService = new ValidatorService();
const rootStore = new RootStore();

const App = () => {
  var element = useRoutes(Routes)

  var navigate = useNavigate();
  rootStore.routerStore = new RouterStore(rootStore, navigate);

  Validator.useLang('hr');

  useEffect(() => {
    rootStore.authorizationStore.authorizeUserAsync();
  }, [])

  return (
    <RootStoreContext.Provider value={rootStore}>
      <ThemeProvider theme={DefaultTheme}>
        {element}
        <Toast />
      </ThemeProvider>
    </RootStoreContext.Provider>
  );
}

export default App;
